<template>
  <template-info :bgImg="bgImg" title="การยื่นขอจด VAT">
    <div>
      <div class="content-title">
        คุณสามารถยื่นคำขอจดทะเบียน VAT ได้เลยวันนี้ โดยสามารถยื่นได้ 2 แบบ
      </div>
      <div>
        <div class="bold">1. ยื่นคำขอจดทะเบียนออนไลน์</div>
        <div class="contents">สามารถยื่นได้เลย ไม่ต้องใช้เอกสารประกอบ</div>
      </div>

      <div class="wivb-next">
        <external-link
          @clickLink="vatOnline"
          caption="ยื่นคำขอจดทะเบียนออนไลน์"
          class="link-desktop"
          style="margin-bottom: 20px;"
        />
      </div>
    </div>
    <div>
      <div class="bold">2. ยื่นคำขอผ่านหน่วยรับจดทะเบียน</div>
      <div class="contents gray">ในเขตกรุงเทพฯ</div>
      <div class="contents">
        ยื่นเอกสารได้ที่สำนักงานสรรพากรพื้นที่
      </div>
      <br />
      <div class="contents gray">นอกเขตกรุงเทพฯ</div>
      <div class="contents">
        ยื่นเอกสารได้ที่สำนักงานสรรพากรพื้นที่สาขาที่สถานประกอบการตั้งอยู่
      </div>
      <br />
      <div class="contents gray">
        ผู้ประกอบการที่อยู่ในการกำกับดูแลของ<br />กองบริหารภาษีธุรกิจขนาดใหญ่
      </div>
      <div class="contents">ยื่นเอกสารได้ที่กองบริหารภาษีธุรกิจขนาดใหญ่</div>
    </div>
    <div class="wivb-next">
      <chevron-right-link
        @clickLink="goRegisterProcess"
        caption="ตรวจสอบเอกสารและขั้นตอนการจดทะเบียน"
      />
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/vat_condition2.png";

export default {
  name: "VatCondition2",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {
    goRegisterProcess() {
      this.$router.push({ path: "/info/register_process" });
    },
  },
};
</script>
<style scoped>
.qualification-vat-knowledge {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.wiv-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 351px;
  position: relative;
}
.wivb-back {
  color: #acb1bf;
  display: flex;
  align-items: center;
  margin-top: 23px;
  margin-bottom: 16px;
  cursor: pointer;
  width: 100%;
}
.wivbb-img-back {
  margin-right: 10px;
}
.wivb-title {
  width: 100%;
  display: flex;
  border-bottom: 1px solid #acb1bf;
}
.wivb-contents {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 23px;
  font-size: 17px;
  color: #393d43;
}
.content-title {
  margin-bottom: 32px;
}
.contents {
  margin-left: 13px;
}
.gray {
  color: #acb1bf;
}
.bold {
  font-weight: bold;
}
.wivb-next {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 13px;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 30px;
}
.wivbn-link {
  cursor: pointer;
  color: #6db6f6;
  display: flex;
  align-items: center;
}
.wivbnl-img {
  margin-left: 8px;
  filter: invert(57%) sepia(92%) saturate(296%) hue-rotate(172deg)
    brightness(101%) contrast(93%);
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .contents br {
    display: none;
  }
}
</style>
